import azlonHero from '../../../media/software/azlon/harrison_presentation_title.png';
import azlonExcel from '../../../media/software/azlon/harrison_presentation_excel.png';
import azlonDesign from '../../../media/software/azlon/design.jpeg';
import RestackUI from '../../../media/software/azlon/RestackUI.png';

const azlonData = {
  name: "Azlon",
  category: "AI/ML",
  tagline: "Autonomous AI code generation platform with iterative debugging",
  duration: "Spring 2025",
  heroImage: azlonHero,

  description: "[[Azlon::https://agentazlon.com/]] is an autonomous coding platform that uses AI agents to generate, validate, and execute code through iterative feedback loops. The backend uses Restack.io for workflow orchestration across concurrent sessions, BAML for type-safe LLM interactions, and E2B sandboxes for isolated Docker execution. When validation fails, an agent-driven debugging loop retries until the code passes. I built the React frontend with Firebase authentication, real-time workflow status, and a syntax-highlighted editor. Files persist in Google Cloud Storage, with event-driven agent communication and Pydantic-structured outputs.",

  techStack: [
    "Python",
    "React",
    "Restack.io",
    "BAML",
    "E2B Sandboxes",
    "Docker",
    "Google Cloud Storage",
    "Firebase Authentication",
    "Pydantic",
    "Microservices Architecture",
    "Workflow Orchestration",
    "AI Agents",
    "TailwindCSS",
    "Boto3",
    "RESTful APIs",
    "Event-Driven Architecture",
    "Framer Motion"
  ],

  gallery: [
    { type: 'image', src: azlonExcel, alt: 'My partner Harrison presenting Azlon to investors at DataMelons Demo Day' },
    { type: 'image', src: azlonDesign, alt: 'Azlons favicon and figma design' },
    { type: 'image', src: RestackUI, alt: 'Azlons workflow orchestration hosted by Restack.io' }
  ],

  links: {
    live: "https://agentazlon.com/"
  }
};

export default azlonData;
